import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  Stack,
  Chip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Skeleton,
  Avatar,
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { api } from "../../utils/api";

export default function ClientInvoices() {
  const { id } = useParams();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/invoices/list.php?client_id=${id}`);
        setInvoices(res.invoices || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
        <Avatar sx={{ bgcolor: "success.main", width: 48, height: 48 }}>
          <ReceiptIcon />
        </Avatar>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>
            Client Invoices
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Invoices issued for client #{id}
          </Typography>
        </Box>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Invoice #</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading &&
              [...Array(3)].map((_, i) => (
                <TableRow key={`sk-${i}`}>
                  <TableCell colSpan={4}>
                    <Skeleton height={36} />
                  </TableCell>
                </TableRow>
              ))}
            {!loading && invoices.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    No invoices yet
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {!loading &&
              invoices.map((inv) => (
                <TableRow key={inv.id} hover>
                  <TableCell>INV#{inv.id}</TableCell>
                  <TableCell>{inv.created_at || "—"}</TableCell>
                  <TableCell>₹{inv.amount || 0}</TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={inv.status || "Unpaid"}
                      color={
                        (inv.status || "").toLowerCase() === "paid"
                          ? "success"
                          : "warning"
                      }
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
